import React from 'react';
import { Box, PageWithSidebar, styled, usePage } from 'bumbag';
import _get from 'lodash/get';
import type { NavigateFunction } from 'react-router-dom';

import { IncompatibleBrowserMessage } from '@medipass/react-core';
import { MainPageWrapper as MainPage } from '@medipass/react-core';
import { WithTitle } from '@medipass/react-core';
import { withRouter } from '@medipass/react-core/router';
import { bootIntercom, shutdownIntercom } from '@medipass/utils/intercom';
import sdk from '@medipass/web-sdk';

import Sidebar from './Sidebar';
import TopTabNavigator from './TopTabNavigator';

import { AUTH_URL_FORCE_LOGIN, TOUCH_MAX_BREAKPOINT } from '../../../../constants';
const Container = styled(Box)`
  @media screen and (max-width: ${TOUCH_MAX_BREAKPOINT}px) {
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    overflow-y: hidden;
  }
`;
type Props = {
  children: React.ReactNode;
  minWidthBreakpoint?: string;
  navigate: NavigateFunction;
  title?: string;
};
AccountPage.defaultProps = {
  minWidthBreakpoint: undefined,
  title: undefined,
};

function AccountPage(props: Props) {
  const { children, navigate, minWidthBreakpoint, title } = props;
  const page = usePage();
  const account = React.useMemo(() => sdk.account || {}, []);
  React.useEffect(() => {
    if (!account) {
      navigate(AUTH_URL_FORCE_LOGIN);
      return;
    }

    bootIntercom({
      email: account.username,
      created_at: account.created,
      user_id: account._id,
      is_plan_consumer: true,
      hide_default_launcher: true,
      intercomHash: sdk.intercomHash,
    });
    return () => shutdownIntercom();
  }, [account, navigate]);
  //eslint-disable-line
  const handleLogout = React.useCallback(async () => {
    await sdk.auth.logout();
    navigate(AUTH_URL_FORCE_LOGIN);
  }, [navigate]);
  //eslint-disable-line
  const username = `${_get(sdk, 'member.firstName', '')} ${_get(sdk, 'member.lastName', '')}`;
  return (
    <WithTitle title={title}>
      <IncompatibleBrowserMessage />
      <PageWithSidebar
        sidebar={
          <Sidebar
            userMenuProps={{
              accountPath: '/account/members',
              onLogout: handleLogout,
            }}
            username={username}
          />
        }
      >
        <Container>
          <TopTabNavigator />
          <MainPage
            minWidthBreakpoint={minWidthBreakpoint}
            showHeader={!page.isCollapsed}
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            title={title}
            userMenuProps={{
              accountPath: '/account/members',
              onLogout: handleLogout,
              username,
            }}
          >
            {children}
          </MainPage>
        </Container>
      </PageWithSidebar>
    </WithTitle>
  );
}

export default withRouter(AccountPage);
